import { changeURLSearchParam } from './base/url'
import { E_ProcessEnv, getProcessEnv } from './base/env'
import Agent from './agent'
import knbUse from './knb/knb-use'
import { mpRedirectTo } from './router/mp-base'
import { WX_PATH_PREFIX } from './router/mp-const'
import { getApp, getPlatform } from './risk-app'
import debug from './base/debug'
import { lxMV } from './lx'

interface Options {
  path?: string
}
export function onMiniProgramLogin(options: Options) {
  let path = options.path || window.location.href
  if (path.indexOf('http') === 0) {
    path = changeURLSearchParam(path, {
      login: 1,
    })
  }
  const pathMap = {
    group_wxapp: `${WX_PATH_PREFIX.meituan}/web/login?from=${encodeURIComponent(path)}`,
    dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}/dynamic-page/index?case=pages-web-login&from=${encodeURIComponent(
      path,
    )}`,
    hotel_wxapp: `${WX_PATH_PREFIX.hotel}/web/login?from=${encodeURIComponent(path)}`,
    phoenix_wxapp: `${WX_PATH_PREFIX.phx}/web/login?from=${encodeURIComponent(path)}`,
  }
  lxMV('b_airbnb_swnpgu0k_mv', {
    custom: pathMap,
  })
  mpRedirectTo(pathMap)
}

function onKnbLogin() {
  lxMV('b_airbnb_glvz14j3_mv')
  knbUse('login', {
    success: () => {
      window.$bus.$emit('login-success')
    },
    fail: (err: {}) => {
      // 关闭登录也会触发
      window.$bus.$emit('login-failed', err)
    },
  })
}

// https://km.sankuai.com/page/211167801
// https://km.sankuai.com/page/211211027 扫码登录
function onPassportLogin() {
  lxMV('b_airbnb_uotgbtkp_mv')
  const continueUrl = changeURLSearchParam(window.location.href, {
    token: undefined,
  })
  const loginUrl = getProcessEnv(E_ProcessEnv.VUE_APP_LOGIN_URL)
  if (Agent.pc && loginUrl) {
    const ssoUrl = `${getProcessEnv(E_ProcessEnv.VUE_APP_LOGIN_SETTOKEN)}/?continue=${btoa(continueUrl)}`
    window.location.href = `${loginUrl}&continue=${encodeURIComponent(ssoUrl)}&risk_partner=${getProcessEnv(
      E_ProcessEnv.VUE_APP_LOGIN_RISK_PARTNER,
    )}`
    return
  }
  // 使用美团I版登录，接入文档: https://km.sankuai.com/page/122501369
  window.location.href = `${getProcessEnv(E_ProcessEnv.VUE_APP_ILOGIN_URL)}&backurl=${encodeURIComponent(
    continueUrl,
  )}&risk_partner=${getProcessEnv(
    E_ProcessEnv.VUE_APP_LOGIN_RISK_PARTNER,
  )}&risk_app=${getApp()}&risk_platform=${getPlatform()}`
}

export default function (options: Options = {}) {
  if (debug['dontlogin']) {
    return
  }
  // 小程序
  if (Agent.anyminiprogram) {
    onMiniProgramLogin(options)
    return
  }
  if (Agent.android_Ios_HarmonyNative) {
    // native
    onKnbLogin()
    return
  }
  // passport
  onPassportLogin()
}
